import React from "react";

interface TabOption {
    id: string
    label: string
}

interface TabsProps {
    options: TabOption[]
    selected?: string
    onChange?: (id: string) => void
}

export default function SimpleTabs({ options, selected, onChange }: TabsProps) {
    const handleSelect = (id: string) => {
        onChange?.(id);
    };

    return (
        <div
            style={{
                display: "inline-flex",
                border: "1px solid #dee2e6",
                borderRadius: "8px",
                padding: "2px",
                backgroundColor: "white",
            }}
        >
            {options.map((option) => (
                <button
                    key={option.id}
                    onClick={() => handleSelect(option.id)}
                    style={{
                        borderRadius: "6px",
                        padding: "8px",
                        fontSize: "0.875rem",
                        fontWeight: 700,
                        color: selected === option.id ? "#3a1045" : "#333333",
                        backgroundColor: selected === option.id ? "#f0e1f7" : "transparent",
                        border: "none",
                        cursor: "pointer",
                        margin: 0,
                        transition: "background-color 0.2s, color 0.2s",
                        lineHeight: 1,
                    }}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
